import React from "react";
import { useParams } from "react-router-dom";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { studentNav } from "../../components/shared/navConfig";
import DirectWorkThread from "../../components/shared/DirectWorkThread";

export default function StudentDirectWorkThread() {
  const { id } = useParams();
  return (
    <DashboardShell nav={studentNav} title="Admin direct work" subtitle="Direct assignment from Assisto4U Admin.">
      <DirectWorkThread dwId={id} backTo="/student/direct-work"/>
    </DashboardShell>
  );
}
